import { jsPDF } from "jspdf";

export function downloadTransactionPDF(data) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const purple = [75, 35, 100];
  const dark   = [25, 12, 60];
  const gray   = [76, 68, 78];
  const light  = [243, 244, 245];

const formatAmount = (amt) => {
  if (amt === null || amt === undefined || amt === "") {
    return "Rs. 0.00";
  }

  // Remove everything except digits and decimal
  const clean = String(amt)
    .replace(/₹/g, "")
    .replace(/,/g, "")
    .trim();

  const number = parseFloat(clean);

  if (isNaN(number)) {
    return "Rs. 0.00";
  }

  return `Rs. ${number.toFixed(2)}`;
};
  // Header bar
  doc.setFillColor(...purple);
  doc.rect(0, 0, W, 80, "F");

  // Company name
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.setTextColor(255, 255, 255);
  doc.text("KlyroPay", 40, 38);

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(220, 200, 240);
  doc.text("Transaction Receipt", 40, 56);

  // Status badge (top right)
  doc.setFontSize(9);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(255, 255, 255);
  doc.text(data.status?.toUpperCase() || "—", W - 40, 44, { align: "right" });

  // Date line
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(200, 180, 220);
  doc.text(`${data.date}  ${data.time}`, W - 40, 58, { align: "right" });

  let y = 110;

  const section = (title) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.setTextColor(...gray);
    doc.text(title.toUpperCase(), 40, y);
    y += 6;
    doc.setDrawColor(220, 210, 230);
    doc.setLineWidth(0.5);
    doc.line(40, y, W - 40, y);
    y += 14;
  };

  const row = (label, value, valueColor = dark) => {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(...gray);
    doc.text(label, 40, y);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.setTextColor(...valueColor);
    doc.text(String(value ?? "—"), W - 40, y, { align: "right" });
    y += 22;
  };

  // Transaction Info
  section("Transaction Information");
  row("Transaction ID",     data.id);
  // row("Partner Request ID", data.partner_request_id);
  // row("Reference ID",       data.idRef);
  row("Service Type",       data.serviceType);
  row("UTR",                data.utr);
//   row("Status",             data.status);
//   row("Date",               data.date);
//   row("Time",               data.time);

  y += 6;

  // Financial Summary
  section("Financial Summary");

  doc.setFillColor(...light);
  doc.roundedRect(40, y - 12, W - 80, 26, 4, 4, "F");
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...gray);
  doc.text("Gross Amount", 52, y + 4);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...dark);
  doc.text(formatAmount(data.grossAmount), W - 52, y + 4, { align: "right" });
  y += 32;

  const isPayin = data.serviceType.toLowerCase().includes("payin") || data.serviceType.toLowerCase().includes("pay_in");
  const commColor  = isPayin ? [239, 68, 68] : [5, 150, 105];
  const commPrefix = data.serviceCommission !== "—" ? (isPayin ? "- " : "+ ") : "";
  row("Service Commission", commPrefix + formatAmount(data.serviceCommission), commColor);

  y += 4;
  doc.setDrawColor(...purple);
  doc.setLineWidth(1);
  doc.line(40, y, W - 40, y);
  y += 16;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.setTextColor(...purple);
  doc.text("Net Total Amount", 40, y);
  doc.setFontSize(14);
  doc.text(formatAmount(data.netTotal), W - 40, y, { align: "right" });
  y += 30;

  // Provider Message
  if (data.message && data.message !== "—") {
    y += 6;
    section("Provider Message");
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(...gray);
    const lines = doc.splitTextToSize(data.message, W - 80);
    doc.text(lines, 40, y);
    y += lines.length * 14;
  }

  // Footer
  const pageH = doc.internal.pageSize.getHeight();
  doc.setFillColor(...purple);
  doc.rect(0, pageH - 36, W, 36, "F");
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(200, 180, 220);
  doc.text("This is a system-generated receipt. For support: support@klyropay.com", W / 2, pageH - 16, { align: "center" });

  doc.save(`receipt-${data.id}.pdf`);
}
